var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.851,
    height: 54.851,
    viewBox: "0 0 54.851 54.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.218,30a.8.8,0,0,0-.8-.8H3.38a1.775,1.775,0,0,1-1.773-1.773V3.38A1.775,1.775,0,0,1,3.38,1.607H27.426A1.775,1.775,0,0,1,29.2,3.38V21.414a.8.8,0,1,0,1.607,0V3.38A3.384,3.384,0,0,0,27.426,0H3.38A3.384,3.384,0,0,0,0,3.38V27.426a3.384,3.384,0,0,0,3.38,3.38H21.414A.8.8,0,0,0,22.218,30Z",
    transform: "translate(0 0)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.878,224.452h-6.87a.8.8,0,1,0,0,1.607h6.87a1.775,1.775,0,0,1,1.773,1.773v24.046a1.775,1.775,0,0,1-1.773,1.773H227.832a1.775,1.775,0,0,1-1.773-1.773V227.832a1.775,1.775,0,0,1,1.773-1.773h13.741a.8.8,0,0,0,0-1.607H227.832a3.383,3.383,0,0,0-3.38,3.38v24.046a3.384,3.384,0,0,0,3.38,3.38h24.046a3.384,3.384,0,0,0,3.38-3.38V227.832A3.384,3.384,0,0,0,251.878,224.452Z",
    transform: "translate(-200.406 -200.406)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.39,65.847H73.465v-.914a.8.8,0,1,0-1.607,0v.914H64.933a.8.8,0,1,0,0,1.607H76.765a22.421,22.421,0,0,1-4.107,7.476,22.616,22.616,0,0,1-3.227-5.177.8.8,0,0,0-1.466.658,24.214,24.214,0,0,0,3.61,5.729A21.737,21.737,0,0,1,67.1,79.7a.8.8,0,1,0,.827,1.378,23.381,23.381,0,0,0,4.735-3.75,23.414,23.414,0,0,0,4.743,3.75.8.8,0,0,0,.827-1.378,21.8,21.8,0,0,1-4.487-3.564,24.157,24.157,0,0,0,2.849-4.169,22.3,22.3,0,0,0,1.853-4.515H80.39a.8.8,0,1,0,0-1.607Z",
    transform: "translate(-57.259 -57.258)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.762,289.295a1.15,1.15,0,0,0-1.067-.715h0a1.15,1.15,0,0,0-1.067.717l-.007.018-5.8,15.24a.8.8,0,1,0,1.5.572l1.248-3.278h8.217l1.236,3.276a.8.8,0,1,0,1.5-.567l-5.752-15.241Zm-4.584,10.948,3.515-9.23,3.483,9.23Z",
    transform: "translate(-271.22 -257.664)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.627,315.941l-3.435-2.576a.8.8,0,1,0-.964,1.286l1.507,1.13H94.992a5.214,5.214,0,0,1-5.208-5.208V305.42a.8.8,0,0,0-1.607,0v5.152a6.823,6.823,0,0,0,6.815,6.815h2.742l-1.507,1.13a.8.8,0,1,0,.964,1.286l3.435-2.576a.8.8,0,0,0,0-1.286Z",
    transform: "translate(-78.731 -271.983)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.934,68.151l3.435,2.576a.8.8,0,1,0,.964-1.286l-1.507-1.13h2.742a5.214,5.214,0,0,1,5.208,5.208v5.152a.8.8,0,0,0,1.607,0V73.52a6.823,6.823,0,0,0-6.815-6.815h-2.742l1.507-1.13a.8.8,0,1,0-.964-1.286l-3.435,2.576a.8.8,0,0,0,0,1.286Z",
    transform: "translate(-271.98 -57.258)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.8e736584.svg";
export { ForwardRef as ReactComponent };